import requests from './requests';

export default {
    get() {
        return requests
            .get('/trainer/coach')
            .then(resp => resp.data);
    },
    getAvailableDates(date) {
        return requests
            .get(`/trainer/coach/available_dates/${date}`)
            .then(resp => resp.data);
    },
    getAvailableTimes(date) {
        return requests
            .get(`/trainer/coach/available_times/${date}`)
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/coach.js